import { useState, useEffect, useCallback } from 'react';
import { useMountedState } from 'react-use';

import { fetchChecklistTemplate } from 'APIPackage/AccountModule/services/checklistTemplatesApi';
import { IChecklistTemplate } from 'APIPackage/AccountModule/interfaces/IChecklistTemplate';

export function useChecklistTemplate(templateId?: number) {
  const isMounted = useMountedState();
  const [isLoading, setIsLoading] = useState(false);
  const [checklistTemplate, setChecklistTemplate] = useState<IChecklistTemplate>();

  const getChecklistTemplate = useCallback(
    async (id: number) => {
      try {
        setIsLoading(true);
        const response = await fetchChecklistTemplate(id);

        if (isMounted()) {
          setChecklistTemplate(response);
        }

        return {
          success: true,
          data: response,
        };
      } catch (err) {
        return {
          success: false,
        };
      } finally {
        isMounted() && setIsLoading(false);
      }
    },
    [isMounted],
  );

  useEffect(() => {
    if (templateId) {
      getChecklistTemplate(templateId);
    }
  }, [templateId, getChecklistTemplate]);

  return {
    isLoading,
    getChecklistTemplate,
    checklistTemplate,
  };
}
